import React,{Component} from 'react'
import './Tracker.css';
import LineChart from './LineChart';
import ToolTip from "./ToolTip"

class Tracker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hoverLoc: null,
      activePoint: null
    }
  }
  handleChartHover(hoverLoc, activePoint){
    this.setState({
      hoverLoc: hoverLoc,
      activePoint: activePoint
    })
  }
  render() {
    return (

      <div className="w-100">
        <div className='row mx-0'>
          <div className='chart w-100'>
            { !this.props.fetchingData ?
            <div>
        <div className='row mx-0'>
          <div className='popup'>
            {this.state.hoverLoc ? <ToolTip hoverLoc={this.state.hoverLoc} activePoint={this.state.activePoint}/> : null}
          </div>
        </div>
              <LineChart data={this.props.data} onChartHover={ (a,b) => this.handleChartHover(a,b) }/>
              </div>
              : null }
          </div>
        </div>
        
      </div>

    );
  }
}

export default Tracker;